import {Link} from 'react-router-dom/cjs/react-router-dom.min';
import Section from '../Section';
import SectionContents from '../SectionContents';
import SectionContentsBody from '../SectionContentsBody';
import SectionContentsCta from '../SectionContentsCta';
import local from './Cta.module.scss';
import {lazy, Suspense} from 'react';

const LandingAsset = lazy(() => import('./LandingAsset'));

export default function LandingFinalCta() {
  return (
    <Section mobilePad="top" outline>
      <SectionContents sizes={{xs: [12, 12], lg: [7, 5]}}>
        <div
          className={`h-100 d-flex flex-column justify-content-center ${local['cta--heading']}`}
        >
          <SectionContentsBody
            title={
              <>
                Make Certification Integrity a Standard <br /> in Your Workflow
              </>
            }
            description={
              <>
                Remove uncertainty, ensure compliance, and build stronger
                business <br /> relationships with ISO certificate verification
                you can trust.
              </>
            }
          >
            <div>
              <SectionContentsCta
                className="mr-3 mb-3 mb-lg-0"
                tag={Link}
                to="/register/user"
              >
                Try for FREE
              </SectionContentsCta>
              <SectionContentsCta tag={Link} to="/plans" outline>
                Explore Plans
              </SectionContentsCta>
            </div>
          </SectionContentsBody>
        </div>

        <Suspense fallback={null}>
          <LandingAsset />
        </Suspense>
      </SectionContents>
    </Section>
  );
}
